import * as React from 'react';

import getHtmlDataSet from 'Utils/GetHtmlDataSet';
import CourseBodyInstructorPage from '../../Instructor/Containers/CourseBodyInstructorPage';
import CourseBodyStudentPage from '../../Student/Containers/CourseBodyStudentPage';

interface IProps {
    match: any;
}

export default class CourseBodyPage extends React.Component<IProps, {}> {
    public render() {
        switch (getHtmlDataSet().mode) {
            case 'I':
                return <CourseBodyInstructorPage match={this.props.match}/>;
            default:
                return <CourseBodyStudentPage match={this.props.match}/>;
        }
    }
}
